// extracted by mini-css-extract-plugin
export var closeButton = "_1t-0";